/* eslint-disable no-useless-computed-key */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useCallback, useRef } from 'react';
import customStyles from "../../../../../assets/styles/customStyles";
import ProductIcon from "../../../../../assets/images/icon_menus/ProductIcon.json";
import MainHeader from "../../../../Shared/components/Header";
import clsx from "clsx";
import { useDispatch, useSelector } from "react-redux";
import ImportIcon from "../../../../../assets/images/icon_actions/Import.svg";
import ExportIcon from "../../../../../assets/images/icon_actions/Export.svg";
import { Row, Col, Image, Space, Modal } from "antd";
import { NavLink, useParams } from "react-router-dom";
import AddIcon from "../../../../../assets/images/icon_actions/Add Icon.svg";
import SearchIcon from "../../../../../assets/images/icon_actions/Search Icon.svg";
import { SelectedIcon, UnSelectedIcon } from "../../../../Shared/components/Icons/selectedIcon";
import { TextField, Typography, FormControl, RadioGroup, FormControlLabel, Radio } from "@mui/material";
import PrimaryCard from "../../../../Shared/components/Card/PrimaryCard";
import { AutoCompleteComponent } from "../../../../Shared/components/AutoCompleteComponent";
import usePrevious from "../../../../Shared/components/Previous";
import crudActions from "../../../../CRUD/redux/actions";
import actions from "../../redux/actions";
import adminActions from "../../../../YounoteAdmin/Product/redux/actions";
import productActions from "../../../Setup/redux/actions";
import DeleteModal from "../../../../Shared/components/DeleteModal";
import { ListTable } from './ListTable';
import { FilterProductGroup } from './FilterProductGroup';
import { checkViewPermission, checkCRUDPermission, checkComponentPermission, idNamingConversion, checkProductSearch, storageSetItem } from '../../../../../helpers/utilities';
import { ImportExport } from '../../../../Shared/components/ImportExport';
import { useEventListener } from "../../../../../helpers/useEventListener";
import FilterIcon from "../../../../../assets/images/icon_actions/Filter Icon.svg";
import FilterReset from "../../../../../assets/images/icon_actions/FilterReset.svg";
import { PrimaryDrawer } from "../../../../Shared/components/Drawer/PrimaryDrawer";
import ClearIcon from "../../../../../assets/images/icon_actions/Clear Icon.svg";

const searchTypes = [
    { id: 'name', label: "Name" },
    { id: 'code', label: "Code" },
    { id: 'both', label: "Both" },
    { id: 'standard', label: "Standard" },
    { id: 'mrp', label: "MRP" }
];

const Products = (props) => {
    const { getList, getData } = useSelector(state => state.crudReducer);
    const [search, setSearch] = useState('');
    const [searchType, setSearchType] = useState(checkProductSearch());
    const { clientProductcatalogueDetails, clientProductcategoryDetails, catalogueDetails } = useSelector(state => state.younoteAdminProductReducer);
    const [iconAnimation, setIconAnimation] = useState(false);
    const prevSearch = usePrevious(search);
    const timeoutRef = useRef(null);

    const [sortOrder, setSortOrder] = useState("desc");
    const [sortBy, setSortBy] = useState("id");
    const [productId, setProductId] = useState('');
    const [loadMore, setLoadMore] = useState(false);
    const [loadMoreContent, setLoadMoreContent] = useState(false);
    const [skip, setSkip] = useState(0);
    const [limit] = useState(25);
    const { groupId } = useParams();
    const { myProductdetails, loader } = useSelector(state => state.productProductReducer);
    const { hsnDetails } = useSelector(state => state.adminSetupReducer);
    const { unitMesurementdetails, productGroupDetails } = useSelector(state => state.productSetupReducer);
    const [deleteModal, setDeleteModal] = useState(false);
    const [product, setProduct] = useState('');
    const [visible, setVisible] = useState(false);
    const [catalogueId, setCatalogueId] = useState(false);
    const [importVisible, setImportVisible] = useState(false);
    const [fillPro, setFillPro] = useState(false);
    const [topBar, setTopBar] = useState({
        groupId: parseInt(groupId),
        type: 'All'
    });
    const [type, setType] = useState('All');
    const { roleManagement } = useSelector(state => state.authReducer);
    const { history } = props;

    const handleCloseMobile = () => {
        setFillPro(false);
    }

    const dispatch = useDispatch();

    const onDelete = (data) => {
        setDeleteModal(true);
        setProductId(data.id);
        setProduct(data?.productName);
    }

    const requestSort = (sortBy, sortOrder) => {
        setSortBy(sortBy);
        setSortOrder(sortOrder);
        dispatchFilter(topBar, sortBy, sortOrder);
    }

    useEffect(() => {
        if (roleManagement !== '') {
            if (checkViewPermission('My Products', history, 'Product')) {
                loadTasks();
            }
        }
    }, [roleManagement]);

    const handleKeyDown = (e) => {
        if (e.altKey && e.keyCode === 78) {
            e.preventDefault();
            history.push(`/product/product/my-products/create`);
        }
    }
    useEventListener("keydown", handleKeyDown);

    const loadTasks = useCallback(() => {
        dispatch({
            type: productActions.PRODUCT_GROUP_DETAILS_START, url: 'product-groups', filter: {
                order: 'id desc'
            }
        });
        dispatch({
            type: adminActions.CLIENT_PRODUCT_CATEGORY_DETAILS_START
        });
        dispatch({
            type: adminActions.CLIENT_PRODUCT_CATALOGUE_DETAILS_START
        });
        dispatch({
            type: adminActions.CATALOGUE_DETAILS_START, filter: {
                order: 'id desc'
            }
        });
        dispatchFilter(topBar, sortBy, sortOrder);
    });

    const customObject = (details, id) => {
        let a = details && details.filter(function (el) { return el.id === id });
        if (a && a?.length !== 0) {
            return a[0];
        }
        return [];
    }


    const prevGetData = usePrevious(getData);
    useEffect(() => {
        if (loadMore && getData === '') {
            setLoadMoreContent(false);
            setLoadMore(true);
        }
        if (prevGetData !== undefined && getData && prevGetData !== getData) {
            const timer = setTimeout(() => {
                if (getData && Array.isArray(getData) && getData.length > 0) {
                    setLoadMore(true);
                    if (getData.length < limit) {
                        setLoadMoreContent(false);
                    } else {
                        setLoadMoreContent(true);
                    }
                } else {
                    setLoadMoreContent(false);
                    setLoadMore(true);
                }
            });

            return () => {
                clearTimeout(timer);
            };
        }
    }, [getData]);

    const buildSearchOr = () => {
        let or = { ["or"]: [] };
        if (search !== '') {
            let array = ['productName', 'productId', 'description', 'skuQuantity', 'status', 'type', 'barcode', 'code'];
            if (checkProductSearch() === 'both') {
                array = ['productName', 'code'];
            } else if (checkProductSearch() === 'name') {
                array = ['productName'];
            } else if (checkProductSearch() === 'code') {
                array = ['code'];
            } else if (checkProductSearch() === 'mrp') {
                array = ['mrp'];
            }
            array.forEach((el) => {
                if (el === 'code' || el === 'mrp') {
                    or['or'].push({ [el]: search.trim() });
                } else {
                    or['or'].push({ [el]: { like: '%' + search.trim() + '%' } });
                }
            });
        }
        return or;
    }

    const changeSearchType = (value) => {
        storageSetItem('productSearch', value);
        setSearchType(value);
        dispatchFilter(topBar, sortBy, sortOrder);
    }

    const dispatchFilter = (topBar, sortBy, sortOrder, skip = 0) => {
        if (skip === 0) {
            setLoadMore(false);
            setLoadMoreContent(false);
        }
        let filter = { ["and"]: [] };
        let or = buildSearchOr();

        // if (groupId !== undefined) {
        //     filter['and'].push({ productGroupId: parseInt(groupId) });
        // }

        if (topBar?.groupId) {
            filter['and'].push({ productGroupId: parseInt(topBar?.groupId) });
        }

        if (topBar?.catalogueId) {
            filter['and'].push({ catalogueId: parseInt(topBar?.catalogueId) });
        }

        if (topBar?.categoryId) {
            filter['and'].push({ categoryId: parseInt(topBar?.categoryId) });
        }
        if (or.or.length > 0) {
            filter['and'].push(or);
        }
        setSkip(skip);
        dispatch({
            type: crudActions.GET_DETAILS_START,
            url: 'client-products',
            skip: skip,
            filter: {
                where: !filter.and || filter.and.length === 0 ? {} : filter,
                order: sortBy + ' ' + sortOrder,
                limit: limit,
                skip: skip
            },
        });
    }

    const loadImportExportData = (name, data = 'existing', selected = [], extension = 'xlsx') => {
        let filter = { ["and"]: [] };
        let or = buildSearchOr();

        if (topBar?.groupId) {
            filter['and'].push({ productGroupId: parseInt(topBar?.groupId) });
        }

        if (topBar?.catalogueId) {
            filter['and'].push({ catalogueId: parseInt(topBar?.catalogueId) });
        }

        if (topBar?.categoryId) {
            filter['and'].push({ categoryId: parseInt(topBar?.categoryId) });
        }

        filter['and'].push(or);
        dispatch({
            type: actions.MYPRODUCT_DETAILS_START,
            export: name,
            data: data,
            selected: selected,
            extension: extension,
            url: 'client-products',
            filter: {
                where: filter,
                order: sortBy + ' ' + sortOrder,
            }
        });
    }

    useEffect(() => {
        if ((prevSearch !== undefined && search && search.length > 0 && prevSearch !== search) || (prevSearch !== undefined && search === '' && prevSearch !== search)) {
            if (timeoutRef.current !== null) {
                clearTimeout(timeoutRef.current);
            }
            if (search === '') {
                dispatchFilter(topBar, sortBy, sortOrder);
            } else {
                timeoutRef.current = setTimeout(() => {
                    timeoutRef.current = null;
                    dispatchFilter(topBar, sortBy, sortOrder);
                }, 500);
            }
        }
    }, [search]);

    const handleDeleteModal = (value) => {
        setDeleteModal(value);
    }

    const loadMoreTask = () => {
        let s = skip + limit;
        dispatchFilter(topBar, sortBy, sortOrder, s);
    }

    const handleOk = () => {
        setVisible(false);
        setCatalogueId('');
    };

    const handleOpen = () => {
        setVisible(true);
        setCatalogueId('');
    };

    const handleTypeChange = (value) => {
        setType(value);
        if (value === 'All') {
            const top = {
                ...topBar,
                catalogueId: '', categoryId: ''
            };
            setTopBar(top);
            dispatchFilter(top, sortBy, sortOrder);
        }
    }
    const mobileFilterOpen = () => {
        if (topBar?.groupId || topBar?.catalogueId || topBar?.categoryId) {
            let data = {
                groupId: parseInt(groupId),
                type: 'All'
            };
            setTopBar(data);
            dispatchFilter(data, sortBy, sortOrder)
        } else {
            setFillPro(true);
        }
    }

    const classes = customStyles();
    return (
        <React.Fragment>
            <MainHeader
                {...props}
                img={ProductIcon}
                title={'Product'}
                closeLink={'/product'}
                links={[{ 'label': 'Product', 'link': '/product' }, { 'label': 'My Products', 'link': '' }]}
            />
            <div className={clsx(classes.margin40, classes.listTableMargin, classes.listTableMarginProduct, classes.listTableMarginProductBottom)}>
                <PrimaryCard
                    title={'My Products'}
                    component={
                        <>
                            <Row align="middle" className={classes.marginBottom20}>
                                <Col xxl={8} xl={9} lg={10} md={12} sm={16} xs={24}>
                                    {
                                        roleManagement !== '' && checkComponentPermission('My Products', 'Action', 'Search') &&
                                        <div className={clsx(classes.dropDownWithSearch, classes.customerLabelNone)}>
                                            <AutoCompleteComponent
                                                customLabel={"Type"}
                                                heads={[{ 'key': 'label', 'name': 'Search Configuration' }]}
                                                details={searchTypes}
                                                parentValue={customObject(searchTypes, searchType)}
                                                position={"bottom"}
                                                variant={'outlined'}
                                                onChange={(data) => changeSearchType(data.id)}
                                            />
                                            <div className={clsx(classes.searchAnimation, { [classes.iconAnimation]: iconAnimation || search !== '' })}>
                                                <TextField autoComplete='one-time-code'
                                                    placeholder={
                                                        searchType === 'standard' ? 'Search Name, ID, Bar Code, Code, Description, and Status' :
                                                            searchType === 'both' ? 'Search Name, and Code' :
                                                                searchType === 'name' ? 'Search Name' :
                                                                    searchType === 'code' ? 'Search Code' :
                                                                        searchType === 'mrp' ? 'Search MRP' : ''
                                                    }
                                                    type='search'
                                                    value={search}
                                                    className={classes.comInput}
                                                    required
                                                    variant={'standard'}
                                                    onChange={(e) => setSearch(e.target.value)}
                                                    fullWidth
                                                    onFocus={() => setIconAnimation(true)}
                                                    onBlur={() => setIconAnimation(false)}
                                                    id={idNamingConversion('Search', 'product', 'TextField')}
                                                />
                                                <Image src={SearchIcon} preview={false} />
                                                {
                                                    search && <NavLink to="#" onClick={() => setSearch('')} className={classes.searchClear}>
                                                        <Image
                                                            src={ClearIcon}
                                                            preview={false}
                                                        />
                                                    </NavLink>
                                                }
                                            </div>
                                        </div>
                                    }
                                </Col>
                                <Col xxl={16} xl={15} lg={14} md={12} sm={8} xs={24} className={clsx(classes.textAlignRight, classes.vertiCalScrollOverFlowParent, classes.customerLabelNone, classes.removeUnderline)}>
                                    <div className={clsx(classes.vertiCalScrollOverFlow, classes.customFilterMyProduct)}>
                                        {

                                            roleManagement !== '' &&
                                            (checkComponentPermission('My Products', 'Action', 'Product Filter') ||
                                                checkComponentPermission('My Products', 'Action', 'All Group')) && <>
                                                <NavLink
                                                    to="#"
                                                    className={clsx(classes.customLink, classes.customFilter)}
                                                    onClick={() => mobileFilterOpen()}>
                                                    {
                                                        topBar?.groupId || topBar?.catalogueId || topBar?.categoryId ?
                                                            <>
                                                                <Image
                                                                    src={FilterReset}
                                                                    preview={false}
                                                                    className={clsx(classes.antImage)}
                                                                /> <span className={clsx(classes.addLink, classes.color, classes.bold, classes.fwMedium)}>Reset Filter</span>
                                                            </>
                                                            : <>
                                                                <Image
                                                                    src={FilterIcon}
                                                                    preview={false}
                                                                    className={clsx(classes.antImage)}
                                                                /> <span className={clsx(classes.addLink, classes.color, classes.bold, classes.fwMedium)}>Filter</span>
                                                            </>
                                                    }
                                                </NavLink>
                                            </>
                                        }
                                        <Space size={[20, 20]} direction="horizontal" align="center">
                                            <div className={clsx(classes.fillterDropdown, classes.customFilterNone)}>
                                                {
                                                    roleManagement !== '' && checkComponentPermission('My Products', 'Action', 'Product Filter') &&
                                                    <>
                                                        <FormControl
                                                            className={clsx(classes.dropDownPointer, classes.customRadioButton)}
                                                            variant={'standard'}
                                                            fullWidth >
                                                            <RadioGroup
                                                                row
                                                                value={type}
                                                                id={idNamingConversion('Product Filter', 'product', 'Radio')}
                                                                onChange={(e) => handleTypeChange(e.target.value)}>
                                                                <FormControlLabel value="All" control={<Radio
                                                                    checkedIcon={<UnSelectedIcon />}
                                                                    icon={<SelectedIcon />}
                                                                />} label="All" />
                                                                <FormControlLabel value="Catalogue" control={<Radio
                                                                    checkedIcon={<UnSelectedIcon />}
                                                                    icon={<SelectedIcon />}
                                                                />} label="Catalogue" />
                                                                <FormControlLabel value="Category" control={<Radio
                                                                    checkedIcon={<UnSelectedIcon />}
                                                                    icon={<SelectedIcon />}
                                                                />} label="Category" />
                                                            </RadioGroup>
                                                        </FormControl>
                                                        {
                                                            type !== 'All' && <>
                                                                {
                                                                    type === 'Catalogue' ?
                                                                        <AutoCompleteComponent
                                                                            customLabel={"All Catalogue"}
                                                                            heads={[{ 'key': 'catalogueName', 'name': 'Name' },
                                                                            { 'key': 'cataloguePrefix', 'name': 'Prefix' }]}
                                                                            details={clientProductcatalogueDetails}
                                                                            customClasses={classes.customFilterNone}
                                                                            parentValue={customObject(clientProductcatalogueDetails, topBar?.catalogueId)}
                                                                            position={"bottom"}
                                                                            variant={'outlined'}
                                                                            id={idNamingConversion('All Catalogue', 'product', 'DropDown')}
                                                                            onChangeText={(data) => {
                                                                                if (data === '') {
                                                                                    setTopBar({
                                                                                        ...topBar, catalogueId: ''
                                                                                    });
                                                                                    dispatchFilter({
                                                                                        ...topBar, catalogueId: ''
                                                                                    }, sortBy, sortOrder);
                                                                                }
                                                                            }}
                                                                            onChange={(data) => {
                                                                                setTopBar({
                                                                                    ...topBar, catalogueId: data.id
                                                                                });
                                                                                dispatchFilter({
                                                                                    ...topBar, catalogueId: data.id
                                                                                }, sortBy, sortOrder);
                                                                            }}
                                                                        /> : <AutoCompleteComponent
                                                                            customLabel={["All Category"]}
                                                                            variant={'outlined'}
                                                                            customClasses={classes.customFilterNone}
                                                                            heads={[{ 'key': 'categoryName', 'name': 'Name' },
                                                                            { 'key': 'parent', 'name': 'Parent', 'relation': 'categoryName' }]}
                                                                            details={clientProductcategoryDetails}
                                                                            id={idNamingConversion('All Category', 'product', 'DropDown')}
                                                                            parentValue={customObject(clientProductcategoryDetails, topBar?.categoryId)}
                                                                            position={"bottom"}
                                                                            onChangeText={(data) => {
                                                                                if (data === '') {
                                                                                    setTopBar({
                                                                                        ...topBar, categoryId: ''
                                                                                    });
                                                                                    dispatchFilter({
                                                                                        ...topBar, categoryId: ''
                                                                                    }, sortBy, sortOrder);
                                                                                }
                                                                            }}
                                                                            onChange={(data) => {
                                                                                setTopBar({
                                                                                    ...topBar, categoryId: data.id
                                                                                });
                                                                                dispatchFilter({
                                                                                    ...topBar, categoryId: data.id
                                                                                }, sortBy, sortOrder);
                                                                            }}
                                                                        />
                                                                }
                                                            </>
                                                        }
                                                    </>
                                                }
                                            </div>
                                            {
                                                roleManagement !== '' && checkComponentPermission('My Products', 'Action', 'All Group') &&
                                                <AutoCompleteComponent
                                                    customLabel={"All Product Group"}
                                                    heads={[{ 'key': 'name', 'name': 'Name' }, { 'key': 'description', 'name': 'Description' }]}
                                                    customClasses={classes.customFilterNone}
                                                    details={productGroupDetails}
                                                    parentValue={customObject(productGroupDetails, topBar?.groupId)}
                                                    position={"bottom"}
                                                    variant={'outlined'}
                                                    id={idNamingConversion('All Category', 'product', 'DropDown')}
                                                    onChangeText={(data) => {
                                                        if (data === '') {
                                                            setTopBar({
                                                                ...topBar, groupId: ''
                                                            });
                                                            dispatchFilter({
                                                                ...topBar, groupId: ''
                                                            }, sortBy, sortOrder);
                                                        }
                                                    }}
                                                    onChange={(data) => {
                                                        setTopBar({
                                                            ...topBar, groupId: data.id
                                                        });
                                                        dispatchFilter({
                                                            ...topBar, groupId: data.id
                                                        }, sortBy, sortOrder);
                                                    }}
                                                />
                                            }
                                            {
                                                roleManagement !== '' && checkComponentPermission('My Products', 'Action', 'Add From Catalogue') &&
                                                <NavLink
                                                    to={"#"}
                                                    onClick={() => handleOpen()}
                                                    className={clsx(classes.customLink)}
                                                    id={idNamingConversion('Add From Catalogue', 'product', 'Link')}>
                                                    <Image
                                                        src={AddIcon}
                                                        preview={false}
                                                        className={clsx(classes.antImage)}
                                                    /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Add From Catalogue</span>
                                                </NavLink>
                                            }
                                            {
                                                roleManagement !== '' && checkCRUDPermission('My Products', 'create', 'Product') &&
                                                <NavLink
                                                    to={`/product/product/my-products/create`}
                                                    //onClick={() => handleAdd()}
                                                    className={clsx(classes.customLink)}
                                                    id={idNamingConversion('Add Product', 'product', 'Link')}>
                                                    <Image
                                                        src={AddIcon}
                                                        preview={false}
                                                        className={clsx(classes.antImage)}
                                                    /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Add Product</span>
                                                </NavLink>
                                            }
                                            {
                                                roleManagement !== '' && checkComponentPermission('My Products', 'Action', 'Export') &&
                                                <NavLink
                                                    to="#"
                                                    onClick={() => { loadImportExportData('My Products'); }}
                                                    className={clsx(classes.customLink)}
                                                    id={idNamingConversion('Export', 'product', 'Link')}>
                                                    <Image
                                                        src={ExportIcon}
                                                        preview={false}
                                                        className={clsx(classes.antImage)}
                                                    /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Export</span>
                                                </NavLink>
                                            }
                                            {
                                                roleManagement !== '' && checkComponentPermission('My Products', 'Action', 'Import') &&
                                                <NavLink
                                                    to="#"
                                                    className={clsx(classes.customLink)}
                                                    onClick={() => { setImportVisible(true); }}
                                                    id={idNamingConversion('Import', 'product', 'Link')}>
                                                    <Image
                                                        src={ImportIcon}
                                                        preview={false}
                                                        className={clsx(classes.antImage)}
                                                    /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Import</span>
                                                </NavLink>
                                            }
                                        </Space>
                                    </div>
                                </Col>
                            </Row>
                            <ListTable
                                search={search}
                                onDelete={(data) => onDelete(data)}
                                details={getList}
                                unit={unitMesurementdetails}
                                hsn={hsnDetails}
                                loadMore={loadMore}
                                loadMoreTask={() => loadMoreTask()}
                                loadMoreContent={loadMoreContent}
                                sortOrder={sortOrder}
                                sortBy={sortBy}
                                handleOpen={() => handleOpen()}
                                roleManagement={roleManagement}
                                onRequestSort={(sortBy, sortOrder) => requestSort(sortBy, sortOrder)}
                            />
                        </>
                    }
                />
            </div>
            <ImportExport
                handleClose={() => { setImportVisible(false); }}
                visible={importVisible}
                title={'My Products'}
                type={'import'}
                loader={loader}
                loadImportExportData={(name, type, selected, extension) => loadImportExportData(name, type, selected, extension)}
                details={myProductdetails}
                loadTasks={() => { dispatchFilter(topBar, sortBy, sortOrder) }}
            />
            <DeleteModal onClose={(v) => handleDeleteModal(v)} id={productId} loadTasks={() => loadTasks()} name={product} url={'client-products'}
                title={'Client Products'} visible={deleteModal} />
            <Modal
                title={'Catalogue Selection'}
                width={650}
                open={visible}
                onOk={() => handleOk()}
                onCancel={() => handleOk()}
                footer={[
                    <NavLink
                        to={`/product/product/my-products/${catalogueId}/catalogueview`}
                        className={clsx(classes.modalBtn, classes.bold, classes.textAlignLeft, { [classes.disabled]: catalogueId === '' })}
                    >OK</NavLink>
                ]}
                className={clsx(classes.commonPopup, classes.commonPopupText, classes.removeUnderline, classes.deletePopup)}>
                <Typography variant={'subtitle1'} className={clsx(classes.fonSize14, classes.textAlignLeft)} style={{ color: "#1c314c" }}>Please choose the Catalogue name  that suits your business and click OK</Typography>
                <Space direction="horizontal" align="center" className={classes.modalPaper} style={{ width: "100%", margin: "0" }}>
                    <AutoCompleteComponent
                        name={["Catalogue Name ", <span key={'Catalogue Name'} className={classes.colorRedRequired}> *</span>]}
                        heads={[{ 'key': 'catalogueName', 'name': 'Name' },
                        { 'key': 'cataloguePrefix', 'name': 'Prefix' }]}
                        details={catalogueDetails}
                        catalogueModal={true}
                        parentValue={customObject(catalogueDetails, catalogueId)}
                        position={"bottom"}
                        customClasses={classes.margin20t}
                        onChange={(data) => setCatalogueId(data.id)}
                    />
                </Space>
            </Modal>
            <PrimaryDrawer
                open={fillPro}
                title={'Filter and Product Group'}
                variant={'temporary'}
                handleClose={() => setFillPro(false)}
                width={"360px"}
                className={clsx(classes.closeBackGround, classes.width100P)}
                component={
                    <FilterProductGroup
                        customObject={(details, id) => customObject(details, id)}
                        roleManagement={roleManagement}
                        clientProductcatalogueDetails={clientProductcatalogueDetails}
                        clientProductcategoryDetails={clientProductcategoryDetails}
                        topBar={topBar}
                        handleSubmit={(topBar) => {
                            setFillPro(false);
                            setTopBar(topBar);
                            dispatchFilter(topBar, sortBy, sortOrder)
                        }}
                        productGroupDetails={productGroupDetails}
                        groupId={groupId}
                        handleCloseMobile={() => handleCloseMobile()}
                        checkComponentPermission={checkComponentPermission}
                    />
                }
            />
        </React.Fragment>
    );
}
export default Products;